import React from "react";
import "./App.css";
// import FirebaseUIAuth from './FirebaseUIAuth';
import firebase from "./firebase";

import { loadUserData } from "./services/data";

import LoginPage from "./pages/Login";
// import NewUserPage from './pages/NewUser'
import Splash from "./pages/Splash";
import UserApp from "./UserApp";
import { withTranslation } from "react-i18next";
import userRoles from "./services/UserRoles";

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: true,
      user: null,
      userExtra: null,
      error: null,
    };
  }

  componentDidMount() {
    // user auth and data loading
    const that = this;
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        that.setState({
          loading: false,
        });
        return;
      }

      user
        .getIdToken(false)
        .then((token) => loadUserData(token))
        .then((userExtra) => {
          that.setState({
            loading: false,
            user,
            userExtra,
            userRole: userRoles[userExtra.role],
          });
        })
        .catch((err) => {
          that.setState({
            loading: false,
            user: null,
            userExtra: null,
            userRole: null,
            error: err,
          });
        });
    });
  }

  renderInner() {
    if (this.state.loading) {
      return <Splash>Loading...</Splash>;
    }
    if (!this.state.user || !this.state.userExtra || !this.state.userRole) {
      return <LoginPage error={this.state.error} />;
    }
    // if (!this.state.userExtra) {
    //   return <NewUserPage userData={this.state.user}/>
    // }
    return (
      <UserApp
        user={this.state.user}
        userExtra={this.state.userExtra}
        userRole={this.state.userRole}
      />
    );
  }

  render() {
    return (
      <div className={`App ${this.props.i18n.dir()}`}>{this.renderInner()}</div>
    );
  }
}

export default withTranslation()(App);
